import type { MemberRoom } from '../../types'
import { roomAllowsBasics, roomAllowsModels } from './memberRooms'
import {
    isLevelAdmin,
    isLevelBasic,
    isLevelGuest,
    isLevelModel,
    isLevelPremium,
    UserAccess,
} from './userProperties/level'

export type RoomJoinBlock = 'premium' | 'models' | 'friends' | null

const isPremiumOrAdmin = (level: UserAccess) =>
    isLevelPremium(level) || isLevelAdmin(level)

export const canUpgradeForMembers = (level: UserAccess) =>
    isLevelGuest(level) || isLevelBasic(level)

export const canWatchMemberWebcams = (level: UserAccess) =>
    isPremiumOrAdmin(level) || isLevelModel(level)

export const canListMemberWebcam = (level: UserAccess) =>
    isPremiumOrAdmin(level)

export const canCreateMemberRoom = (level: UserAccess) =>
    isPremiumOrAdmin(level)

export const showCreateMemberRoom = (level: UserAccess) =>
    isLevelBasic(level) || canCreateMemberRoom(level)

export const canJoinMemberRoom = (
    room: Pick<MemberRoom, 'permissions'>,
    level: UserAccess,
) => {
    if (isPremiumOrAdmin(level)) return true
    if (isLevelBasic(level)) return roomAllowsBasics(room)
    if (isLevelModel(level)) return roomAllowsModels(room)
    return false
}

export const canEditMemberTags = (level: UserAccess) =>
    isLevelBasic(level) || isPremiumOrAdmin(level)
